// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e931e158","452":"f93e5f1e","455":"c7760800","977":"09def3af"}[chunkId] + ".chunk.js";
};